class BundleVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('product-id') || null;
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this._elements = {};
    this._elements.fieldset = this.querySelector('.bundle-variant-selector__fieldset') || this;
    this._elements.legend = this.querySelector('.bundle-variant-selector__legend') || this;
    this._elements.options = this.querySelectorAll('.bundle-variant-selector__option') || [];
    this._elements.radios = this.querySelectorAll('input[type="radio"][name="bundle-variant"]') || [];
    this.rechargeBundleVariantOptionName = this.getAttribute('recharge-bundle-variant-option-name') || null;
    this.defaultVariantId = this.getAttribute('default-variant-id') || null; // Used for non-absorbency products with only one variant (non-selectable).
    this.defaultVariantTitle = this.getAttribute('default-variant-title') || null;
    this.subscriptionProductId = this.getAttribute('subscription-product-id') || null;
  }

  connectedCallback() {
    this.addEventListener('change', this.handleVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleVariantChange);
  }

  getCurrentSelection() {
    if (this.defaultVariantId) {
      return {
        subscriptionProductId: this.subscriptionProductId,
        variantId: this.defaultVariantId,
        rechargeBundleVariantOptionName: this.rechargeBundleVariantOptionName,
        variantTitle: this.defaultVariantTitle,
        isDefault: true,
      }
    }

    const selectedRadio = [...this._elements.radios].find(radio => radio.checked);
    
    return {
        subscriptionProductId: this.subscriptionProductId,
        variantId: selectedRadio?.value,
        rechargeBundleVariantOptionName: this.rechargeBundleVariantOptionName,
        variantTitle: selectedRadio?.dataset.variantTitle
    }
  }

  handleVariantChange(event) {
    const payload = this.getCurrentSelection();

    this.dispatchEvent(new CustomEvent('bundle-variant:change', {
      detail: payload
    }));
  }
}

customElements.define('bundle-variant-selector', BundleVariantSelector);